import {Directive, ElementRef, HostListener} from '@angular/core';

@Directive({
  selector: '[mobile]',
  standalone: true
})
export class MobileDirective {
  constructor(private el: ElementRef<HTMLInputElement>) {
  }

  @HostListener('input', ['$event'])
  onInput(e: Event) {
    const input = this.el.nativeElement as HTMLInputElement;
    let v = (input.value || '').replace(/\D/g, '');
    if (v === '' || v === '0' || v.startsWith('09')) {
    } else if (v[0] === '9') {
      v = '0' + v;
    } else if (v[0] === '0') {
      v = '09' + v.slice(2);
    } else {
      v = '09' + v;
    }
    if (v.length > 11) v = v.slice(0, 11);
    if (input.value !== v) {
      input.value = v;
      input.dispatchEvent(new Event('input', {bubbles: true}));
    }
  }
}
